import React from 'react';
import { useConfirmedMeetings } from '../../../../../../data/hooks/meeting/useConfirmedMeetings';
import CommonTabContent from '../CommonTabContent';

function ConfirmedMeetings(props) {
    const { eventId } = props,
        meetings = useConfirmedMeetings(eventId);

    return <CommonTabContent eventId={eventId} meetings={meetings} />;
}

export default ConfirmedMeetings;
